import { FC, useEffect, useState } from "react";
import { NavItemIconProps } from "./types";
import { Column } from "../../../../../containers";
import { useLocation } from "react-router";
import { useThemeStore } from "../../../../../../stores";
import { JustifyContent } from "../../../../../containers/types";

const NavItemIcon: FC<NavItemIconProps> = ({ Icon, pathname }) => {
  const theme = useThemeStore((state) => state.theme);
  const location = useLocation();
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    if (pathname === "/") setActive(location.pathname === pathname);
    else setActive(location.pathname.includes(pathname));
  }, [location, pathname]);

  return (
    <Column
      style={{ width: 40, height: 40, borderRadius: 7 }}
      background={active ? theme.primary : "transparent"}
      className="transition"
      justifyContent={JustifyContent.Center}
    >
      <Icon
        color={active ? theme.textOnprimary : theme.icon}
        className="transition"
        height={24}
        width={24}
      />
    </Column>
  );
};

export default NavItemIcon;
